export default {"src":"/_next/static/media/EHAQA-green.13c510b4.svg","height":25,"width":94};